var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"text-center",staticStyle:{"border-radius":"15px"},attrs:{"title":_vm.cardTitle,"border-variant":"light","bg-variant":"primary"}},[_c('b-card-text',{staticClass:"text-left",staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.cardBody))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }